import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M28.6591 28.0909L39.0227 57.4773H39.4318L49.7955 28.0909H54.2273L41.4091 63H37.0455L24.2273 28.0909H28.6591Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
